var $ = require( 'jquery' );
import 'select2';
import magnificPopup from 'magnific-popup';

$( document ).ready( function() {
	handleTabs(); 
    initPopups(); 
});

var root = $('html,body');

function handleTabs() {
	const tabs = $('.section-about-us__tab');
	const tabsContent = $('.section-about-us__team');
	if( tabs.length ) {
		tabs.off('click').on('click', function(e) {
			e.preventDefault();
			if( !$(this).hasClass('active') ) {
				const index = $(this).attr('data-index');
				const tabContent = $('.section-about-us__team[data-index="' + index + '"]');
				tabs.removeClass('active');
				tabsContent.removeClass('active');
				$(this).addClass('active');
				tabContent.addClass('active');
			}
		});
	}

    //MOBILE Select2
    
	var teamSelectContainer = $('.section-about-us__tabs .tabs-mobile__select');
	teamSelectContainer.select2({
		selectOnClose: true,
		minimumResultsForSearch: -1,
		dropdownParent: $('.section-about-us__tabs.tabs-mobile')
	});

	teamSelectContainer.on('select2:select', function (e) {
        console.log(e);
		var data = e.params.data;
		$('.section-about-us__team').removeClass('active');
		$('.section-about-us__team[data-index="'+data.id+'"]').addClass('active');
	});

}

function initPopups() {
	$('.popup-trigger').off('click').on('click', function(e) {
		e.preventDefault();
		root.addClass('noscroll');
        console.log($(this));
		const popupWrapper = $(this).next('.popup-wrapper');
		if( $('.mfp-bg.mfp-fade.mfp-ready').length ) {
			$.magnificPopup.close();
			setTimeout(function() {
				openPopup(popupWrapper);
			}, 300);
		} else {
			openPopup(popupWrapper);
		}

	});
	$('.popup-wrapper__close').off('click').on('click', function(e) {
		e.preventDefault();
		$.magnificPopup.close();
		root.removeClass('noscroll');
	});

    $('.popup-trigger').hover(function() {
        console.log($(this).find('.overlay'));
        $(this).find('.overlay').addClass('hover');
    }, function() {
        $(this).find('.overlay').removeClass('hover');
    });

    $('.select2-results__option').on('click', function() {
        $('.popup-trigger').find('.overlay').removeClass('hover');
    });
}

function openPopup(popupWrapper) {
	$.magnificPopup.open({
		items: {
			src: popupWrapper
		},
		type: 'inline',
		removalDelay: 300,
		mainClass: 'mfp-fade',
		closeOnBgClick: true,
		closeBtnInside: false,
		showCloseBtn: false,
		callbacks: {
			close: function() {
				root.removeClass('noscroll');
			}
		}
	});
}